import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const VisualizerFireIntensityListItem = (props) => {
    const { fireSettingsIntensity, updateVisualizerSettings, maxFireIntensity } = props;
    
    const onFireIntensityChange = (value) => {
        previewHistoryBatch.start();
        
        updateVisualizerSettings({ 
            fireSettings: { intensity: value } 
        });
    };
    
    return (
        <SliderListItem
            title='Intensity'
            value={fireSettingsIntensity}
            displayMultiplier={100 / maxFireIntensity}
            min={0}
            max={100}
            step={1}
            onValueChange={onFireIntensityChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { intensity: fireSettingsIntensity } = state.createPreview.present.videoSettings.visualizer.fireSettings;
    const { maxFireIntensity } = state.create.maxValues;

    return { 
        fireSettingsIntensity,
        maxFireIntensity
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerFireIntensityListItem);